var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row gutter-x-md items-center" }, [
    _c(
      "div",
      {
        class: {
          "col-12": _vm.isNewSetting && !_vm.currentSetting,
          "col-sm-6 col-xs-12": _vm.currentSetting
        }
      },
      [
        _vm.currentSetting && !_vm.isNewSetting
          ? _c("strong", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.capitalize(_vm.currentSetting.key).replace(/_/g, " ")
                  ) +
                  " "
              ),
              _c("small", [
                _vm._v("("),
                _c("code", [_vm._v(_vm._s(_vm.currentSetting.key))]),
                _vm._v(")")
              ])
            ])
          : _c(
              "q-input",
              {
                attrs: { "float-label": "Setting", clearable: "" },
                on: { input: _vm.settingQueryChange },
                model: {
                  value: _vm.settingQuery,
                  callback: function($$v) {
                    _vm.settingQuery = $$v
                  },
                  expression: "settingQuery"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: { "min-characters": 1 },
                  on: {
                    search: _vm.settingSearch,
                    selected: _vm.settingSelected
                  }
                })
              ],
              1
            ),
        _vm.currentSetting
          ? _c("div", [
              _c("p", { staticClass: "no-margin" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.currentSetting.description) +
                    "\n      "
                )
              ]),
              _vm.currentSetting.validation_rules
                ? _c(
                    "p",
                    { staticClass: "no-margin text-grey" },
                    [
                      _c("small", [_vm._v("Validation rules: ")]),
                      _vm._l(
                        _vm.currentSetting.validation_rules.split("|"),
                        function(rule, ruleIndex) {
                          return _c(
                            "q-chip",
                            {
                              key: ruleIndex,
                              class: ruleIndex ? "q-ml-sm" : "",
                              attrs: { small: "", dense: "" }
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(rule) + "\n        "
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      1
    ),
    _vm.currentSetting
      ? _c(
          "div",
          {
            staticClass: "text-right",
            class: {
              "col-12": _vm.isNewSetting && !_vm.currentSetting,
              "col-sm-6 col-xs-12": _vm.currentSetting
            }
          },
          [
            _c("div", { staticClass: "row items-center gutter-x-sm" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _vm.currentSetting.type === "toggle"
                    ? _c("q-toggle", {
                        attrs: { readonly: !_vm.editable },
                        on: { input: _vm.update },
                        model: {
                          value: _vm.currentSetting.value,
                          callback: function($$v) {
                            _vm.$set(_vm.currentSetting, "value", $$v)
                          },
                          expression: "currentSetting.value"
                        }
                      })
                    : _c("q-input", {
                        attrs: {
                          "inverted-light": "",
                          color: "grey-2",
                          type: _vm.currentSetting.type,
                          "stack-label": "Value",
                          readonly: !_vm.editable
                        },
                        on: { input: _vm.update },
                        model: {
                          value: _vm.currentSetting.value,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.currentSetting,
                              "value",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "currentSetting.value"
                        }
                      }),
                  _vm.currentSetting.children
                    ? _c(
                        "ul",
                        { staticClass: "text-left" },
                        _vm._l(_vm.currentSetting.children, function(
                          childrenSetting
                        ) {
                          return _c(
                            "li",
                            { key: childrenSetting.id },
                            [
                              childrenSetting.market
                                ? [
                                    _vm._v(
                                      "\n              Market override for " +
                                        _vm._s(childrenSetting.market.name) +
                                        ": "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(childrenSetting.value))
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        })
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-auto" },
                [
                  _vm.isNewSetting
                    ? _c("q-btn", {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        attrs: {
                          rounded: "",
                          color: "primary",
                          icon: "save",
                          outline: "",
                          title: "Save setting"
                        },
                        on: { click: _vm.storeSetting }
                      })
                    : _vm._e(),
                  _vm.deletable
                    ? _c("q-btn", {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        attrs: {
                          rounded: "",
                          color: "negative",
                          icon: "delete",
                          outline: "",
                          title: "Delete setting"
                        },
                        on: { click: _vm.deleteSetting }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }